import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SkipperFormModel } from '@shared/models/forms/skipper-form.model';
import { createCustomerDataForm } from '@shared/factories/customer-form.factory';
import { createSkipperRechtsschutzForm } from '../../features/skipper/factories/skipper-rechtsschutz-form.factory';
import { createSkipperHaftpflichtForm } from '../../features/skipper/factories/skipper-haftpflicht-form.factory';
import { Country } from '@backend/models';

export function createSkipperForm(): FormGroup<SkipperFormModel> {
  return new FormGroup<SkipperFormModel>({
    customerData: createCustomerDataForm(),
    skipperHaftpflicht: createSkipperHaftpflichtForm(),
    skipperRechtsschutz: createSkipperRechtsschutzForm(),
    isKundeSkipperVertragsHaftpflichtSelected: new FormControl<boolean>(false),
    isKundeSkipperVertragsRechtsschutzSelected: new FormControl<boolean>(false),
    personLandHauptwohnsitz: new FormControl<Country | null>(null, [Validators.required])
  });
}

